export default __webpack_public_path__ + "static/media/hide.abb6322d.svg";